import isNative from '@unifyapps/network/utils/native/isNative';
import { inIframe } from '../../../../../../hooks/useLink';
import type { PageEvent } from '../types';

// Send page events to parent window when running in iframe
const propagateEventsToIframe = (event: PageEvent) => {
  if (isNative()) {
    return;
  }
  if (inIframe()) {
    window.parent.postMessage(
      {
        source: 'unifyapps',
        type: 'onPageEvent',
        data: {
          eventType: event.label,
          eventPayload: event.eventPayload,
        },
      },
      '*',
    );
  }
};

export default propagateEventsToIframe;
